export default __webpack_public_path__ + "static/media/detail2.867c63a2.jpeg";